import { months } from "moment";
import React from "react";

import "./PrintTemplate.css";
import { useTranslation } from "react-i18next";

interface Props {
  toningData: any;
}

const translationPrefix = 'Printing';

const PrintTemplateS3 = (props: Props) => {
  const getFormattedDate = () => {

    var date = new Date();
    var month = date.getMonth() + 1;
    var formattedMonth = month < 10 ? `0${month}` : month;
    var year = date.getFullYear();
    var day = date.getDate();
    var formattedDay = day < 10 ? `0${day}` : day;

    return `${formattedDay}.${formattedMonth}.${year}`;
  }

  const { t } = useTranslation(undefined, { keyPrefix: translationPrefix });
  return (

    <div className="printContainer">
    

      <div className="row">
        <div className="col-4 row">
          <span className="printTextS1">{t('SampleBook')}</span></div>
        <div className="col-6 row">
          <span className="printTextS1" style={{ fontWeight: 'bold' }}> {props.toningData.sampleCardName}</span>
        </div>
      </div>
      <div className="row">
        <div className="col-4 row">
          <span className="printTextS1"> {t('Color')}</span>
        </div>
        <div className="col-6 row">
          <span className="printTextS1" style={{ fontWeight: 'bold' }}>  {props.toningData.colorName}</span>
        </div>
      </div>
      <div className="row">
        <div className="col-4 row">
          <span className="printTextS1">  {props.toningData.specialReceiptName ? t('Receptura') : t('Product')}</span>
        </div>
        <div className="col-6 row">
          <span className="printTextS1" style={{ fontWeight: 'bold' }}>{props.toningData.specialReceiptName || props.toningData.productName}</span>
        </div>
      </div>
      <div className="row">
        <div className="col-4 row">
          <span className="printTextS1">    {t('Base')}</span>
        </div>
        <div className="col-6 row">
          <span className="printTextS1" style={{ fontWeight: 'bold' }}>  {props.toningData.baseName}</span>
        </div>
      </div>
      <div className="row">
        <div className="col-4 row" >
          <span className="printTextS1">   {t('Package')}</span>
        </div>
        <div className="col-6 row">
          <span className="printTextS1" style={{ fontWeight: 'bold' }}>  {props.toningData.formattedBaseVolumeKg}</span>
        </div>
      </div>

      {props.toningData && props.toningData.pigments && props.toningData.pigments.length > 0 &&
        <div className="row receiptHeaderS">
          <div className="col-12">
            <table className="printPigmentsTableS">

              <tbody>
                {props.toningData && props.toningData.pigments && props.toningData.pigments.length > 0 &&
                  props.toningData.pigments.map((pigment: any) => {
                    return <tr>
                      <td>{pigment.name}</td>
                      {pigment.unitCode == 'Oz' && <>
                        <td className="rightAlignment">{pigment.formattedAmountInMl}</td>
                        {props.toningData.yFormatIsActive && <td className="rightAlignment">{pigment.formattedAmountInYFormat}</td>}
                        {!props.toningData.yFormatIsActive && <td className="rightAlignment">{pigment.formattedAmountInUnit}</td>}
                      </>}
                      {pigment.unitCode != 'Oz' && <td className="rightAlignment">{pigment.formattedAmountInUnit}</td>}
                      <td className="rightAlignment">{pigment.formattedPrice}</td>
                    </tr>
                  })
                }
              </tbody>

            </table>
          </div>
        </div>
      }

      {props.toningData && props.toningData.hardeners && props.toningData.hardeners.length > 0 &&
        <div className="row receiptHeaderForHardeners">
          <div className="col-12">
            <table className="printHardenersTableS">

              <tbody>
                {props.toningData && props.toningData.hardeners && props.toningData.hardeners.length > 0 &&
                  props.toningData.hardeners.map((hardener: any) => {

                    return <tr>
                      <td>{hardener.name}</td>
                      {hardener.unitCode == 'Oz' && <>
                        <td className="rightAlignment">{hardener.formattedAmountInMl}</td>
                        {props.toningData.yFormatIsActive && <td className="rightAlignment">{hardener.formattedSize}</td>}
                        {!props.toningData.yFormatIsActive && <td className="rightAlignment">{hardener.formattedSize}</td>}
                      </>}
                      {hardener.unitCode != 'Oz' && <td className="rightAlignment">{hardener.formattedSize}</td>}
                      <td className="rightAlignment">{hardener.formattedPrice}</td>
                    </tr>
                  })
                }
              </tbody>

            </table>
          </div>
        </div>
      }




      <div className="row">
        <div className="col-5 row">
          <span className="printTextS1"> {t('TotalAmount')}</span>
        </div>
        <div className="col-5 row">
          <span className="printTextS1" style={{ fontWeight: 'bold' }}>   {props.toningData.formattedPigmentsVolume}</span>

        </div>
      </div>



  <div className="row rightAlignment" style={{ float: 'right' }}>
       
        <div className="col-4 row rightAlignment" style={{ float: 'right' }}>
          <span className="printTextS1 rightAlignment" style={{ float: 'right' }}>{`${getFormattedDate()}`}</span>
        </div>
      </div>


    </div>
  );
}

export default PrintTemplateS3;
